/*
 * @Author: wuxi
 * @Date: 2022-03-01 10:21:12
 * @LastEditors: wuxi
 * @LastEditTime: 2022-04-21 17:30:19
 * @FilePath: \csx-b2b-front-supplier\api\askPriceManagement.js
 * @Description:
 *
 *
 */

/** 证件名称list*/
export const ASKPRICEMANAGMENT_GET_ZONE = {
  url: 'api/supplierFreightConfig/distribution/temperatureZone',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 城市下啦*/
export const ASKPRICEMANAGMENT_GET_CITY = {
  url: 'api/supplierFreightConfig/deliverableCity',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新增*/
export const ASKPRICEMANAGMENT_GET_SAVEITEM = {
  url: 'api/supplierFreightConfig/saveSupplierFreightConfig',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 新增*/
export const ASKPRICEMANAGMENT_GET_DELETE = {
  url: 'api/supplierFreightConfig/delSupplierFreightConfig',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 查询*/
export const ASKPRICEMANAGMENT_GET_SEARCH = {
  url: 'api/supplierFreightConfig/loadPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 管理品类*/
export const API_GET_LOAD_MANAGEMENT_CATEGORY_TREE = {
  url: 'api/winBidCandidateProductPool/loadManagementCategoryTree',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 商品候选池列表*/
export const API_GET_LOAD_MANAGEMENT_LOADPAGELIST = {
  url: 'api/winBidCandidateProductPool/loadPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 商品候选池列表导出*/
export const API_GET_LOAD_MANAGEMENT_LOADPAGEEXPORTLIST = {
  url: 'api/winBidCandidateProductPool/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 商品报价确认报价*/
export const API_GET_LOAD_MANAGEMENT_QUOTEPRICE = {
  url: 'api/supplierQuotedPrice/manual/quotedPrice',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 根据co单+商品维度查询已分拣数量*/
export const API_POST_ENTRUST_SORTING_CO_LIST = {
  url: 'entrust/sorting/co/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 询价管理-发起人搜索
export const API_POST_SUPPLIERQUOTEDPRICE_FINDUSERS = {
  url: 'api/supplierQuotedPrice/findUsers',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 询价管理-列表
export const API_POST_SUPPLIERQUOTEDPRICE_HEADER_LIST = {
  url: 'api/supplierQuotedPrice/header/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 询价管理-列表
export const API_POST_SUPPLIERQUOTEDPRICE_HEADER = {
  url: 'api/supplierQuotedPrice/inquiry/header',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 效期维护-列表
export const API_POST_DIRECT_VALIDDATE_LIST = {
  url: 'direct/validDate/queryPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 效期维护-保存
export const API_POST_DIRECT_MAINTENANCE_LIST = {
  url: 'direct/validDate/maintenance',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 违约处置单-列表
export const API_POST_DISPOSEORDER_LIST = {
  url: 'supplier/disposeOrder/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 违约处置单-详情
export const API_POST_DISPOSEORDER_DETAIL = {
  url: 'supplier/disposeOrder/detail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 违约处置单-处理
export const API_POST_DISPOSEORDER_HANDLE = {
  url: 'supplier/disposeOrder/handle',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 违约处置单-处理
export const API_USER_FIND_USER = {
  url: 'supplier/user/findUsers',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
